import { MutationFunctionOptions } from '@apollo/client';

import { TeamMemberTransitionInput } from '__generated__/GQL';
import useErrorHandledMutation from 'common/hooks/useErrorHandledMutation';
import { TeamMembersDocument } from 'features/Team/hooks/useTeamMembers/teamMembers.gql';

import {
  ApplyTeamMemberRoleDocument,
  ApplyTeamMemberRoleMutation,
} from './useApplyTeamMemberRole.gql';

export const useApplyTeamMemberRole = ({
  companyProfileId = '',
  companyUserId = '',
}: {
  companyUserId?: string;
  companyProfileId?: string;
}) => {
  const [mutate, hooks] = useErrorHandledMutation(ApplyTeamMemberRoleDocument);

  return {
    applyTeamMemberRole: (
      input: Omit<TeamMemberTransitionInput, 'companyUserId'>,
      options?: Omit<
        MutationFunctionOptions<ApplyTeamMemberRoleMutation>,
        'refetchQueries' | 'variables'
      >,
    ) => {
      return mutate({
        refetchQueries: [
          {
            query: TeamMembersDocument,
            variables: {
              companyProfileId: companyProfileId || '',
            },
          },
        ],
        variables: {
          input: { companyUserId, ...input },
        },
        ...options,
      });
    },
    ...hooks,
  };
};
